<template>
  <main class="toronto">
    <Menu />
    <hero />
    <sponsors />
    <agenda />
    <speakers />
    <presenters />
  </main>
</template>

<style lang="scss" scoped>
  @import '@/styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/toronto/menu.vue';
import hero from '@/components/toronto/hero.vue';
import agenda from '@/components/toronto/agenda.vue';
import sponsors from '@/components/toronto/sponsors.vue';
import speakers from '@/components/toronto/speakers.vue';
import presenters from '@/components/toronto/presenters.vue';

export default {
  name: 'Home',
  components: {
    Menu,
    hero,
    agenda,
    sponsors,
    presenters,
    speakers
  },
};
</script>

<style lang="scss" scoped>
  .toronto {
    &#single-schedule {
      padding: 30px 0;
    }
  }
</style>